import { render, staticRenderFns } from "./discoverAustralia.vue?vue&type=template&id=523514cd&scoped=true&"
import script from "./discoverAustralia.vue?vue&type=script&lang=js&"
export * from "./discoverAustralia.vue?vue&type=script&lang=js&"
import style0 from "./discoverAustralia.vue?vue&type=style&index=0&id=523514cd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523514cd",
  null
  
)

export default component.exports